module.exports = __webpack_public_path__ + "static/media/mode-510.a6c4aad1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-510.svg
// module id = 1040
// module chunks = 2